import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux'
import { loginStaff } from '../../redux/staffSlice';
import { useNavigate, Redirect } from "react-router-dom";

const Loggin = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const staffData = useSelector((state) => state.staff)

    const [credentials, setCredentials] = useState({ username: "", password: "" });

    const handleChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };



    const handleSubmit = (e) => {
    e.preventDefault();
      const resultAction = dispatch(loginStaff(credentials));
    };

    useEffect(()=>{
        if (staffData.status === "succeeded"){
            navigate('/administration', {replace : true, relative: "path"})
        }

    },[staffData])
    
    return (
        <div className='max-w-md mx-auto mt-10 p-6 border rounded-lg shadow-xl bg-[#f7bfd8a2]'>
            <h2 className='text-center text-2xl font-bold mb-6'>Login</h2>
            <form onSubmit={handleSubmit}>
                <div className='mb-4'>
                    <label className='block mb-2 text-orange-600 font-bold'>User:</label>    
                    <input
                        name="username"
                        type="text"
                        placeholder="Nom d’utilisateur"
                        value={credentials.username}   
                        onChange={handleChange}
                        required
                        className="w-full mb-3 rounded-lg focus:outline-none p-2"                    />
                </div>

                <div className='mb-4'>
                    <label className='block mb-2 text-orange-600 font-bold'>Password:</label>
                    <input
                        name="password"
                        type="password"
                        placeholder="Password"
                        value={credentials.password} 
                        onChange={handleChange}
                        required
                        className='w-full p-2 rounded-lg'
                    />
                </div>
                
                <button type="submit" 
                    disabled={staffData.status === "loading"}
                    className='w-full p-2 rounded-lg bg-orange-600 hover:bg-orange-800 text-white'>
                        Submit
                </button>

                {staffData.error && <div className='text-red-500 mb-2'>{staffData.error}</div>}
            </form>
        </div>
    );
};

export default Loggin;
